import React from 'react';
import { Modal, Progress, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import './UploadProgressModal.css';

const UploadProgressModal = ({ visible, current, total }) => {
  const percent = total > 0 ? Math.round((current / total) * 100) : 0;

  return (
    <Modal
      open={visible}
      footer={null}
      closable={false}
      centered
      width={400}
    >
      <div className="upload-progress-container">
        <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
        <h3 style={{ marginTop: 24, marginBottom: 16 }}>Uploading Items...</h3>
        <Progress percent={percent} status="active" />
        <p style={{ marginTop: 16, color: '#666' }}>
          {current} of {total} items uploaded
        </p>
      </div>
    </Modal>
  );
};

export default UploadProgressModal;
